let ErrorMessage = function(errorData) {
    "use strict";

    if (errorData && errorData !== null) {
        if (!errorData.hasOwnProperty('mustResolve')) {
            errorData.mustResolve = true;
        }

        this.text = errorData.text;
        this.details = errorData.details;
        this.mustResolve = errorData.mustResolve;
    }

    this.toJSON = function() {
        let errorMessage = {};
        errorMessage.text = this.text;
        errorMessage.details = this.details;
        return errorMessage;
    };

    // ---------------------------------------------
    //
    //        Define all setter methods.
    //
    // ---------------------------------------------
    this.setText = function(newText) {
        this.text = newText;
    };
    this.setDetails = function(newDetails) {
        this.details = newDetails;
    };

    // ---------------------------------------------
    //
    //        Define all getter methods.
    //
    // ---------------------------------------------
    this.getText = function() {
        return this.text;
    };
    this.getDetails = function() {
        return this.details;
    };
};

export default ErrorMessage;